import { render, staticRenderFns } from "./physicianFeeSchedule.vue?vue&type=template&id=06b70652&"
import script from "./physicianFeeSchedule.vue?vue&type=script&lang=js&"
export * from "./physicianFeeSchedule.vue?vue&type=script&lang=js&"
import style0 from "./physicianFeeSchedule.vue?vue&type=style&index=0&slot-scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports